import axios from "axios";
import range from "lodash/range";
import process from "prop-types/prop-types";
import React, { useState } from "react";
import useSWR from "swr";

import { getToken } from "../lib/authentication";
import { custom_fetcher } from "../lib/fetcher";
import { request_methods } from "../lib/request_methods";
import Form from "./Form";
import FormCheckbox from "./FormCheckbox";
import FormSelect from "./FormSelect";
import FullScreenLoader from "./FullScreenLoader";

export default function TeacherInfoForm({ user, onSubmit }) {
  const { data } = useSWR(
    [`${process.env.REACT_APP_BASE_URL}teachers/`, request_methods.options],
    custom_fetcher
  );

  const [may_be_contacted, setMay_be_contacted] = useState(
    user.teacher ? user.teacher["may_be_contacted"] : null
  );

  const [training_finished, setTraining_finished] = useState(
    user.teacher ? user.teacher["training_finished"] : null
  );
  const [year_training_finished, setYear_training_finished] = useState(
    user.teacher ? user.teacher["year_training_finished"] : null
  );

  const [age, setAge] = useState(user.teacher ? user.teacher["age"] : null);

  const [gender, setGender] = useState(
    user.gender ? user.teacher["gender"] : null
  );

  const [canton, setCanton] = useState("");

  if (!data) return <FullScreenLoader />;

  const currentYear = new Date().getFullYear();
  const fields = data.actions.POST;

  return (
    <Form>
      <h2 className="t-text-h2">Informationen zur Lehrperson</h2>
      <FormCheckbox
        label="Haben Sie Ihre Ausbildung zur Lerhperson bereits abgeschlossen?"
        value={training_finished}
        options={[
          { text: "Ja, ich habe meine Ausbildung abgeschlossen.", value: true },
          { text: "Nein, ich bin noch in der Ausbildung.", value: false },
        ]}
        onChange={(newValue) => setTraining_finished(newValue)}
      />
      <FormSelect
        label={
          training_finished || training_finished === null
            ? "Wann haben Sie Ihre Ausbildung abgeschlossen?"
            : "Wann werden Sie Ihre Ausbildung voraussichtlich abschliessen?"
        }
        options={range(
          training_finished ? currentYear - 44 : currentYear,
          training_finished ? currentYear : currentYear + 3 + 1
        ).map((year) => ({ text: `${year}`, value: year }))}
        disabled={training_finished === null}
        onChange={(e) => setYear_training_finished(e.target.value)}
      />
      <FormSelect
        label="Bitte geben Sie Ihr Alter an."
        options={range(18, 70).map((age) => ({
          text: `${age}`,
          value: age,
        }))}
        onChange={(e) => setAge(parseInt(e.target.value))}
      />
      <FormSelect
        label="Bitte geben Sie Ihr Geschlecht an."
        options={[
          { text: "männlich", value: "M" },
          { text: "weiblich", value: "F" },
          { text: "keine Angabe", value: "X" },
        ]}
        onChange={(e) => setGender(e.target.value)}
      />
      <FormSelect
        label={
          "Bitte geben Sie den Kanton an, in dem Sie als Lehrperson arbeiten."
        }
        options={fields.canton.choices.map((canton) => ({
          text: canton.display_name,
          value: canton.value,
        }))}
        onChange={(e) => setCanton(e.target.value)}
      />
      <p></p>
      <FormCheckbox
        label='Wenn Sie uns den Kontakt erlauben, können wir Sie mit weiterführenden
        Informationen zum Thema "Kognitive Aktivierung" im Bereich der Forschung
        und Weiterbildung auf dem Laufenden halten.'
        value={may_be_contacted}
        options={[
          { text: "Ja, ich möchte kontaktiert werden.", value: true },
          { text: "Nein, ich möchte nicht kontaktiert werden.", value: false },
        ]}
        onChange={(newValue) => setMay_be_contacted(newValue)}
      />
      <div className="FormButtons">
        <button
          className="Button color-primary size-large"
          style={{
            marginRight: "unset",
            marginLeft: "auto",
          }}
          onClick={async (e) => {
            e.preventDefault();
            await axios.post(
              `${process.env.REACT_APP_BASE_URL}teachers/`,
              {
                may_be_contacted: may_be_contacted,
                training_finished: training_finished,
                year_training_finished: year_training_finished,
                age: age,
                gender: gender,
                canton: canton,
              },
              {
                headers: { Authorization: `Token ${getToken()}` },
              }
            );
            onSubmit();
          }}
        >
          Absenden
        </button>
      </div>
    </Form>
  );
}
